export default function About() {
  return (
    <section id="about" className="bg-amber-50 py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* Left Column - Text Content */}
          <div>
            <span className="text-orange-600 font-semibold text-xs uppercase tracking-wider">
              FENETREPRO LYON - 100% RÉPARATION
            </span>
            
            <h2 className="text-3xl lg:text-5xl font-extrabold text-gray-900 mt-6 mb-8 leading-tight">
              Nous Réparons Vos Fenêtres, Nous Ne Les Remplaçons Pas
            </h2>

            <div className="space-y-6 text-gray-700 text-base leading-relaxed mb-10">
              <p>
                Depuis 2009, FenetrePro Lyon est <strong>exclusivement spécialisé dans la réparation et l'entretien de fenêtres</strong>. Nous n'installons pas de fenêtres neuves, nous redonnons vie à vos menuiseries existantes. Notre métier : diagnostiquer, réparer et entretenir. Découvrez <a href="/blog/choisir-fenetres-lyon" className="text-teal-600 hover:text-teal-700 underline font-medium">comment choisir le bon réparateur</a>.
              </p>
              <p>
                Fenêtre qui ne ferme plus ? Vitrage fissuré ? Quincaillerie cassée ? Problème d'étanchéité ? Nos techniciens certifiés interviennent sur tous types de menuiseries : <a href="/reparation-fenetre-pvc-lyon" className="text-teal-600 hover:text-teal-700 underline font-medium">PVC</a>, <a href="/reparation-fenetre-alu-lyon" className="text-teal-600 hover:text-teal-700 underline font-medium">aluminium</a>, <a href="/reparation-fenetre-bois-lyon" className="text-teal-600 hover:text-teal-700 underline font-medium">bois</a> et mixte. <strong>Nous réparons au lieu de remplacer</strong>, pour un coût 3 à 5 fois inférieur.
              </p>
              <p>
                Notre expertise : <a href="/remplacement-quincaillerie-fenetre-lyon" className="text-teal-600 hover:text-teal-700 underline font-medium">remplacement de quincaillerie</a>, réparation de mécanismes, changement de joints, <a href="/blog/renovation-fenetres-anciennes-lyon" className="text-teal-600 hover:text-teal-700 underline font-medium">rénovation de boiseries</a>, <a href="/blog/entretien-fenetres-pvc-lyon" className="text-teal-600 hover:text-teal-700 underline font-medium">entretien préventif</a>. Chaque intervention prolonge la durée de vie de vos fenêtres de 10 à 15 ans. <a href="#contact" className="text-teal-600 hover:text-teal-700 underline font-medium">Diagnostic gratuit</a> sous 24h.
              </p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-4 lg:gap-6 mb-10">
              <div className="text-center">
                <div className="text-2xl lg:text-3xl font-bold text-teal-600 mb-1">2500+</div>
                <div className="text-xs lg:text-sm text-gray-600">Fenêtres réparées</div>
              </div>
              <div className="text-center">
                <div className="text-2xl lg:text-3xl font-bold text-teal-600 mb-1">15 ans</div>
                <div className="text-xs lg:text-sm text-gray-600">D'expertise réparation</div>
              </div>
              <div className="text-center">
                <div className="text-2xl lg:text-3xl font-bold text-teal-600 mb-1">100%</div>
                <div className="text-xs lg:text-sm text-gray-600">Réparation uniquement</div>
              </div>
            </div>

            {/* Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="#gallery"
                className="bg-teal-600 text-white px-8 py-3.5 rounded-full font-semibold hover:bg-teal-700 transition-all text-center whitespace-nowrap cursor-pointer"
              >
                Nos Réparations
              </a>
              <a
                href="#contact"
                className="bg-transparent border-2 border-teal-600 text-teal-600 px-8 py-3.5 rounded-full font-semibold hover:bg-teal-600 hover:text-white transition-all text-center whitespace-nowrap cursor-pointer"
              >
                Demander une Réparation
              </a>
            </div>
          </div>

          {/* Right Column - Image */}
          <div className="relative">
            <div className="rounded-3xl overflow-hidden shadow-2xl shadow-teal-500/20">
              <img
                src="https://public.readdy.ai/ai/img_res/fa59e8f53587e91f62e7e8cb5061c0f8.jpg"
                alt="Technicien réparation fenêtres Lyon"
                className="w-full h-full object-cover"
                loading="lazy"
                decoding="async"
                fetchpriority="low"
              />
            </div>

            {/* Floating Badge */}
            <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl shadow-xl p-6 max-w-xs">
              <div className="flex items-center space-x-4">
                <div className="w-14 h-14 bg-gradient-to-br from-teal-500 to-cyan-400 rounded-full flex items-center justify-center">
                  <i className="ri-tools-fill text-white text-2xl"></i>
                </div>
                <div>
                  <div className="font-bold text-gray-900">100% Réparation</div>
                  <div className="text-sm text-gray-600">Pas de pose neuve</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
